import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { Router } from '@angular/router';
import { InvestCarouselResponse } from '@app/@shared/model/invest.model';
import { InvestService } from '@app/@shared/services/api/invest.service';
import { TranslateService } from '@ngx-translate/core';
import { finalize, Subscription } from 'rxjs';

@Component({
  selector: 'app-nav-tooltip-invest',
  templateUrl: './nav-tooltip-invest.component.html',
  styleUrls: ['./nav-tooltip-invest.component.scss'],
})
export class NavTooltipInvestComponent implements OnInit, OnDestroy {
  cards: InvestCarouselResponse[] = [];
  isLoading!: boolean;
  language!: string;
  @Output() cardSelected = new EventEmitter<InvestCarouselResponse>();
  @Output() closeTooltip = new EventEmitter<boolean>();

  langChangeSubscription: Subscription;

  // Devuelve los cards visibles, ordenados por 'order'
  get visibleCards() {
    return this.cards
      .filter((card) => card.image_view)
      .sort((a, b) => a.image_order - b.image_order);
  }

  // Configuración de posiciones por idioma
  get tooltipArrowPosition() {
    const positions: { [key: string]: string } = {
      es: '165px', // Español
      en: '155px', // Inglés
    };
    return positions[this.language] || '165px';
  }

  constructor(
    public translateService: TranslateService,
    private router: Router,
    private investService: InvestService
  ) {
    this.language = this.translateService.currentLang;
    this.langChangeSubscription = this.translateService.onLangChange.subscribe(
      (event) => {
        this.language = event.lang;
      }
    );
  }

  ngOnInit() {
    this.getCarousel();
  }

  ngOnDestroy() {
    if (this.langChangeSubscription) {
      this.langChangeSubscription.unsubscribe();
    }
  }
  getCarousel() {
    this.isLoading = true;
    this.investService
      .getCarousel()
      .pipe(finalize(() => (this.isLoading = false)))
      .subscribe((data) => (this.cards = data));
  }

  goNavigateToUrl(card: any) {
    const customCreateUrl = `/${this.language}/${card.path}`;
    this.router.navigate([customCreateUrl]);
    this.cardSelected.emit(card);
  }

  goNavigateToUrlAll() {
    const customCreateUrl = `/${this.language}/invertir`;
    this.router.navigate([customCreateUrl]);
    this.closeTooltip.emit(false);
  }
}
